<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M10.92 4.929c0-.513.415-.929.928-.929h8.304a.93.93 0 01.929.929v6.92a.929.929 0 01-.93.928H16.93v2.294h5.988a.93.93 0 01.929.929v3.223h3.225a.93.93 0 01.929.929v6.919a.929.929 0 01-.929.929h-8.303a.929.929 0 01-.93-.929v-5.99h-3.677v5.99a.929.929 0 01-.929.929H4.93a.929.929 0 01-.93-.929v-6.92c0-.512.416-.928.929-.928h3.22V16a.93.93 0 01.929-.929h5.993v-2.294h-3.223a.929.929 0 01-.929-.929V4.93zm8.303 5.99V5.86h-6.446v5.06h6.446zm-9.216 6.01v2.294h11.98v-2.294h-11.98zm-4.149 4.152v5.06h6.445v-5.06H5.858zm13.839 0v5.06h6.445v-5.06h-6.445z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'webSystemHierarchyOutline'
}
</script>
